import { render } from "./BaseSearchBar.vue?vue&type=template&id=ffd496dc"
import script from "./BaseSearchBar.vue?vue&type=script&lang=ts"
export * from "./BaseSearchBar.vue?vue&type=script&lang=ts"
script.render = render

export default script